import React from 'react';

import { Button, HStack } from '@rtkwlf/fenrir-react';

export type ActionButtonsProps = {
  onCancel: () => void;
  showCancel?: boolean;
  isLoading: boolean;
  isActionButtonDisabled?: boolean;
  cancelLabel: string;
  confirmLabel: string;
};

export const ActionButtons: React.FC<ActionButtonsProps> = ({
  cancelLabel,
  confirmLabel,
  onCancel,
  isLoading,
  showCancel,
  isActionButtonDisabled,
}) => {
  return (
    <HStack yAlign="center" xAlign="right" width="full">
      {showCancel && (
        <Button variant="link" onClick={onCancel} isDisabled={isLoading}>
          {cancelLabel}
        </Button>
      )}
      <Button
        variant="primary"
        isDisabled={isActionButtonDisabled}
        type="submit"
        isLoading={isLoading}
      >
        {confirmLabel}
      </Button>
    </HStack>
  );
};
